import { css } from '@emotion/react';

export const fonts = css`
  @font-face {
    font-family: 'LB Centro Serif';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-mediumitalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-mediumitalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-mediumitalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-mediumitalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-mediumitalic.ttf')
        format('truetype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bolditalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bolditalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bolditalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bolditalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bolditalic.ttf')
        format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-italic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-italic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-italic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-italic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-italic.ttf')
        format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Slab';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bolditalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bolditalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bolditalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bolditalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bolditalic.ttf')
        format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-regular.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-regular.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-regular.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-regular.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-regular.ttf')
        format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Slab';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-regular.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-regular.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-regular.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-regular.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-regular.ttf')
        format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-regular.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-regular.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-regular.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-regular.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-regular.ttf')
        format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif Cond';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-mediumitalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-mediumitalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-mediumitalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-mediumitalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-mediumitalic.ttf')
        format('truetype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-medium.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-medium.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-medium.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-medium.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-medium.ttf')
        format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-mediumitalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-mediumitalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-mediumitalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-mediumitalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-mediumitalic.ttf')
        format('truetype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Slab';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-medium.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-medium.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-medium.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-medium.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-medium.ttf')
        format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif Cond';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-italic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-italic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-italic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-italic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-italic.ttf')
        format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif Cond';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-medium.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-medium.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-medium.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-medium.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-medium.ttf')
        format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif Cond';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bold.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bold.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bold.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bold.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bold.ttf')
        format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-italic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-italic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-italic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-italic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-italic.ttf')
        format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Slab';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-italic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-italic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-italic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-italic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-italic.ttf')
        format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thinitalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thinitalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thinitalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thinitalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thinitalic.ttf')
        format('truetype');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif Cond';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-regular.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-regular.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-regular.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-regular.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-regular.ttf')
        format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thin.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thin.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thin.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thin.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-thin.ttf')
        format('truetype');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bolditalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bolditalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bolditalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bolditalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bolditalic.ttf')
        format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bold.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bold.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bold.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bold.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-bold.ttf')
        format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-lightitalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-lightitalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-lightitalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-lightitalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-lightitalic.ttf')
        format('truetype');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bold.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bold.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bold.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bold.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserif-bold.ttf')
        format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Serif Cond';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bolditalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bolditalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bolditalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bolditalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroserifcond-bolditalic.ttf')
        format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Slab';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-mediumitalic.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-mediumitalic.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-mediumitalic.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-mediumitalic.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-mediumitalic.ttf')
        format('truetype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-medium.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-medium.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-medium.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-medium.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-medium.ttf')
        format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Slab';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bold.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bold.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bold.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bold.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentroslab-bold.ttf')
        format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'LB Centro Sans';
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-light.eot');
    src: url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-light.eot?#iefix')
        format('embedded-opentype'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-light.woff2')
        format('woff2'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-light.woff')
        format('woff'),
      url('https://cdn.landsbankinn.is/fonts/centro/lbcentrosans-light.ttf')
        format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
`;
